//package/index.js
import PTable from "@/package-admin/p-table/index.js";
import PTableColumn from "@/package-admin/p-table/Table-column/index";
import PTestButton from "@/package-admin/p-test-button/index.vue";

// 所有组件
const components = [
    PTable,
    PTableColumn,
    PTestButton
];

// install 方法
const install = function (Vue) {
    components.forEach((com) => {
        Vue.component(com.name, com);
    });
};

// 支持按需引入
export { PTable, PTableColumn, PTestButton };

// 支持全局引入
export default install;
